import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="chat-scroll"
export default class extends Controller {
  connect() {
    this.scrollToBottom()
    document.addEventListener('turbo:render', this._scroll = () => {
      requestAnimationFrame(() => this.scrollToBottom())
    })
  }

  disconnect() {
    document.removeEventListener('turbo:render', this._scroll)
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
